import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const cardImages: Record<string, string> = {
  "top-sneakers-2025": "https://readdy.ai/api/search-image?query=Stylish%20white%20sneakers%20with%20colorful%20accents%20on%20minimal%20concrete%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20background%2C%20high%20detail%2C%20clean%20fashion%20aesthetic&width=600&height=480&seq=article-card-sneakers&orientation=landscape",
  "capsule-wardrobe-guide": "https://readdy.ai/api/search-image?query=Minimalist%20wardrobe%20essentials%20hanging%20on%20a%20wooden%20rack%20in%20neutral%20colors%2C%20soft%20morning%20light%2C%20Scandinavian%20interior%2C%20editorial%20photography%2C%20warm%20beige%20tones%2C%20high%20detail&width=600&height=480&seq=article-card-capsule&orientation=landscape",
  "budget-streetwear-tips": "https://readdy.ai/api/search-image?query=Casual%20streetwear%20hoodie%20and%20sneakers%20flatlay%20on%20textured%20concrete%2C%20golden%20hour%20warm%20lighting%2C%20editorial%20urban%20fashion%20photography%2C%20earthy%20neutral%20tones%2C%20high%20detail&width=600&height=480&seq=article-card-budget&orientation=landscape",
  "spreadsheet-vs-traditional": "https://readdy.ai/api/search-image?query=Laptop%20displaying%20organized%20data%20table%20beside%20a%20notebook%20on%20clean%20desk%2C%20soft%20daylight%2C%20editorial%20workspace%20photography%2C%20warm%20neutral%20composition%2C%20high%20detail%2C%20modern%20minimal&width=600&height=480&seq=article-card-compare&orientation=landscape",
  "seasonal-fashion-trends": "https://readdy.ai/api/search-image?query=Fabric%20swatches%20and%20color%20palette%20cards%20arranged%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20design%20studio%20photography%2C%20warm%20earthy%20tones%2C%20high%20detail%2C%20creative%20aesthetic&width=600&height=480&seq=article-card-trends&orientation=landscape",
  "quality-hoodies-guide": "https://readdy.ai/api/search-image?query=Closeup%20detail%20of%20premium%20thick%20cotton%20hoodie%20fabric%20texture%2C%20soft%20natural%20daylight%2C%20editorial%20textile%20photography%2C%20warm%20cream%20tones%2C%20high%20detail%2C%20luxurious%20cozy%20feel&width=600&height=480&seq=article-card-hoodie&orientation=landscape",
  "winter-fashion-2025": "https://readdy.ai/api/search-image?query=Cozy%20wool%20scarf%20and%20leather%20gloves%20on%20warm%20wooden%20surface%2C%20soft%20candlelight%20ambiance%2C%20editorial%20winter%20fashion%20photography%2C%20cream%20and%20camel%20tones%2C%20high%20detail%2C%20hygge%20aesthetic&width=600&height=480&seq=article-card-winter&orientation=landscape",
  "accessories-shopping-guide": "https://readdy.ai/api/search-image?query=Elegant%20watch%20and%20sunglasses%20on%20cream%20marble%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%2C%20warm%20golden%20neutral%20tones%2C%20high%20detail%2C%20luxurious%20minimal&width=600&height=480&seq=article-card-accessories&orientation=landscape",
  "beginners-guide-spreadsheet": "https://readdy.ai/api/search-image?query=Fresh%20clean%20desk%20with%20open%20laptop%20notebook%20and%20coffee%2C%20morning%20sunlight%2C%20minimal%20workspace%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%2C%20calm%20productive%20vibe&width=600&height=480&seq=article-card-beginner&orientation=landscape",
};

export default function ArticlePreviewSection() {
  const featuredArticle = articles[0];
  const cardArticles = articles.slice(1);

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm text-accent-600 font-medium tracking-wide uppercase mb-2">2025 Style Guide</p>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 max-w-2xl leading-tight">
            {featuredArticle.title}
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 md:gap-16 mb-14 md:mb-20">
          <div className="lg:w-[45%]">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Navigating the world of online fashion shopping can be overwhelming with countless stores, varying prices, and inconsistent quality across different categories. The Pandabuy Spreadsheet system was designed to solve exactly this problem — giving fashion enthusiasts a structured, data-driven way to compare outfits, track prices, and discover better alternatives across 14 product categories including Shoes, Hoodies, T-Shirts, Jackets, and more.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              What makes the Pandabuy spreadsheet approach different from traditional fashion blogs and review sites is its systematic comparison framework. Instead of reading through lengthy individual reviews for each item, users can instantly scan structured data tables that compare key attributes like price, material quality, sizing accuracy, and shipping options across multiple products simultaneously.
            </p>
            <Link
              to={`/article/${featuredArticle.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-[55%] flex gap-4">
            <div className="w-[42%] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20studio%20workspace%20with%20laptop%20and%20fabric%20swatches%20on%20a%20clean%20oak%20desk%2C%20soft%20natural%20light%20from%20large%20window%2C%20editorial%20photography%2C%20warm%20cream%20and%20sand%20tones%2C%20high%20detail%2C%20creative%20organized%20aesthetic&width=600&height=800&seq=article-feat-img-01-v2&orientation=portrait"
                alt="Fashion spreadsheet research workspace"
                title="Pandabuy Sheet Guide - Fashion Research Workspace"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="w-[58%] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20flatlay%20of%20curated%20fashion%20items%20with%20a%20notebook%20on%20cream%20linen%20texture%2C%20soft%20natural%20daylight%2C%20editorial%20styling%20photography%2C%20warm%20neutral%20palette%2C%20high%20detail%2C%20harmonious%20minimal%20composition&width=900&height=800&seq=article-feat-img-02-v2&orientation=portrait"
                alt="Curated fashion items flatlay with notebook"
                title="Pandabuy Sheet - Curated Fashion Collection"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="mb-8">
          <p className="text-xs md:text-sm text-accent-600 font-medium tracking-wide uppercase mb-2">More Guides</p>
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            Explore Our Full Collection of Shopping Guides
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer hover:border-background-300 transition-colors block"
            >
              <div className="aspect-[5/4] overflow-hidden">
                <img
                  src={cardImages[article.slug] || cardImages["top-sneakers-2025"]}
                  alt={article.imageAlt}
                  title={article.imageTitle}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                {article.tag && (
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium mb-2 whitespace-nowrap">
                    {article.tag}
                  </span>
                )}
                <h4 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">
                  {article.title}
                </h4>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-foreground-400">{article.readTime}</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read More
                    <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors"
          >
            Browse All Spreadsheets
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}